import _ from 'lodash'
import { createCompRef, compQueriesRefs, NodeRefs, CompNode, dataNodes } from '@wix/thunderbolt-catharsis'
import { CssFeature } from '@wix/thunderbolt-catharsis-extensions'
import { Component } from '@wix/thunderbolt-becky-types'
import { CompNodeAdapter, DataNodeAdapter } from './compNodeAdapter'

export function getNodesFromFeatures(features: Record<string, CssFeature<any>>) {
	const cssFeatures = Object.values(features)
	const renderableNodeToFeature: Record<string, string> = {}
	const catharsisNodes = cssFeatures.reduce((acc, feature) => {
		const currentRenderableNodes = Object.keys(feature.renderableNodes)
		Object.assign(acc, feature.intermediateNodes, feature.renderableNodes)
		currentRenderableNodes.forEach(
			(renderableNode) => (renderableNodeToFeature[renderableNode] = feature.featureName)
		)
		return acc
	}, {})
	const refs = createRefs(catharsisNodes)
	return {
		nodes: _.mapValues(catharsisNodes, (compNode) => CompNodeAdapter(compNode, refs)),
		renderableNodeToFeature,
	}
}

export function getDataNodes() {
	return _.mapValues(dataNodes, (dataNode) => DataNodeAdapter(dataNode))
}

function createRefs(nodes: Record<string, CompNode<any, any, any>>) {
	const refs = {
		..._.mapValues(nodes, (__, key) => (component: Component | string) =>
			createCompRef(key, typeof component === 'string' ? component : component.id)
		),
		...compQueriesRefs,
		modes: (modeId: string) => createCompRef('modes', modeId),
	} as NodeRefs<any>
	return refs
}
